import { PlusIcon } from '@heroicons/react/16/solid';
import { TableCellsIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { Button } from 'react-daisyui';
import { randomString } from '../../../functions/string.functions';
import {
  AGENDA_TEMPLATE_CREATION_TAB,
  AGENDA_VIEW_TABS,
} from '../Agenda.constants';
import styles from '../agenda.module.scss';
import { tAgendaTab } from '../Agenda.types';
import { eAgendaTabs } from './Calendar/Calendar.enums';
import { useCalendarContext } from './Calendar/Calendar.hook';
import { useUserContext } from '../../../providers/UserProvider/User.context.ts';
import { eUserRole } from '../../../providers/UserProvider/User.enums.ts';

export default function AgendaTabMenu(): React.ReactElement {
  const {
    changeView,
    setShowCreateEvent,
    setCurrentTab,
    currentTab,
    templates,
  } = useCalendarContext();
  const { currentUserRole } = useUserContext();

  const buttonActive = templates && templates?.length > 0;

  return (
    <div className={styles.AgendaTabMenu}>
      {AGENDA_VIEW_TABS.map((tab: tAgendaTab) => (
        <div
          onClick={() => {
            setCurrentTab(tab.selectedTab);
            changeView(tab.view);
          }}
          className={`${currentTab === tab.selectedTab ? styles.AgendaTabActive : styles.AgendaTab}`}
          key={randomString()}
        >
          {tab.title}
        </div>
      ))}
      <div className={styles.AgendaTabMenu__Container}>
        <Button
          color="primary"
          disabled={!buttonActive}
          startIcon={<PlusIcon className={styles.IconMd} />}
          onClick={() => {
            if (!buttonActive) return;

            setShowCreateEvent(true);
          }}
        >
          Agregar Evento
        </Button>
      </div>

      {currentUserRole !== eUserRole.SELLER ? (
        <Button
          className={`${
            currentTab === eAgendaTabs.TEMPLATES
              ? styles.AgendaTemplateTabActive
              : styles.AgendaTemplateTab
          } `}
          variant="outline"
          startIcon={<TableCellsIcon className="w-6" />}
          onClick={() => setCurrentTab(eAgendaTabs.TEMPLATES)}
        >
          {AGENDA_TEMPLATE_CREATION_TAB.title}
        </Button>
      ) : null}
    </div>
  );
}
